﻿import { Language, LanguageName } from "../enums/language";

export default {
    methods: {
        setImagesAttributes() {
            //Get all images
            let images = document.getElementsByTagName('img');

            //HTML collection works only with for cycle
            for (let i = 0; i < images.length; i++) {
                //Set height attribute

                if (images[i].clientHeight > 0)
                    images[i].setAttribute('height', images[i].clientHeight.toString());

                //Set width attribute
                if (images[i].clientWidth > 0)
                    images[i].setAttribute('width', images[i].clientWidth.toString());
            }
        },

        windowsWidthSize() {
            return window.innerWidth;
        },

        setMetaTags(title, description) {
            //set title
            if (title && title.length)
                document.title = title;

            if (description && description.length) {
                let metaDescription = document.querySelector('meta[name="description"]');

                if (metaDescription)
                    metaDescription.setAttribute("content", description);
            }
        },

        getLanguageIdByName(title) {
            switch (title) {
                case LanguageName.FR:
                    return Language.French;
                case LanguageName.ES:
                    return Language.Spanish;
                default:
                    return Language.English;
            }
        }
    }
};